import React from "react"
import { Alert, Box, Button, ForwardIcon, Typography } from "@carrotfertility/carotene-core"
import { FormattedMessage } from "react-intl"

type Props = { onContinue: () => void }
export function InsuranceCoveredStep({ onContinue }: Props): JSX.Element {
  return (
    <Box
      sx={(theme) => ({
        inlineSize: "100%",
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(theme.tokens.spacing.lg)
      })}
    >
      <Alert severity="success">
        <FormattedMessage defaultMessage="Your insurance plan covers this type of appointment" />
      </Alert>
      <Typography variant="h4" component="h1">
        <FormattedMessage defaultMessage="You'll see your estimated cost after you choose a time" />
      </Typography>
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Button variant="contained" color="secondary" onClick={() => onContinue()} endIcon={<ForwardIcon />}>
          <FormattedMessage defaultMessage="Continue" />
        </Button>
      </Box>
    </Box>
  )
}
